
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainRegistrantInfoModel extends Model<DomainRegistrantInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'vatNumber', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'postalCode', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'countryCode', type: 'string' },
		{ name: 'contactName', type: 'string' },
		{ name: 'email', type: 'string' },
		{ name: 'phone', type: 'string' },
		{ name: 'invalidData', type: 'string[]', isArray: true }
	];
	[key: string]: any;
	
	public vatNumber: string;
	public companyName: string;
	public address: string;
	public postalCode: string;
	public city: string;
	public countryCode: string;
	public contactName: string;
	public email: string;
	public phone: string;
	public invalidData: string[];
    
	constructor(){
		super();
		this.vatNumber = '';
		this.companyName = '';
		this.address = '';
		this.postalCode = '';
		this.city = '';
		this.countryCode = '';
		this.contactName = '';
		this.email = '';
		this.phone = '';
		this.invalidData = [];
		
	}
	getProperties(){
		return DomainRegistrantInfoModel.classProperties;
	}
}

